import React, { FC } from "react";
import { Snackbar } from "@carrier-io/air-react";
import {
  NotificationBgColor,
  NotificationPosition,
  VerticalPosition,
  HorizontalPosition,
} from "../../types/notification";

interface NotificationProps {
  isNotificationOpened: boolean;
  textContent: string;
  notificationBgColor?: NotificationBgColor;
  autoHideDuration?: number;
  transitionDuration?: number;
  anchorOriginConfig?: NotificationPosition;
  onCloseNotification: () => void;
}

const Notification: FC<NotificationProps> = ({
  isNotificationOpened,
  textContent,
  notificationBgColor = NotificationBgColor.INFO,
  anchorOriginConfig = {
    vertical: VerticalPosition.BOTTOM,
    horizontal: HorizontalPosition.CENTER,
  },
  autoHideDuration = 5000,
  transitionDuration = 500,
  onCloseNotification,
}) => {
  return (
    <Snackbar
      data-testid="notification"
      anchorOrigin={anchorOriginConfig}
      sx={{
        ".MuiSnackbarContent-root": {
          backgroundColor: notificationBgColor,
        },
      }}
      message={textContent}
      onClose={onCloseNotification}
      open={isNotificationOpened}
      autoHideDuration={autoHideDuration}
      transitionDuration={transitionDuration}
    />
  );
};

export default Notification;
